<template>
  <div class="visit-forms">
    <associationNotice @changePage="changePage" @click="toDetails" :list="list" :total="total" v-loading="loading"></associationNotice>
  </div>
</template>

<script>
import associationNotice from '@/components/associationNotice.vue';
import {findRoute} from '@/utils/routerHelper.js'
import {dynamics} from '@/api/api.js';

export default {
  components:{
    associationNotice
  },
  data(){
    return {
      list:[],
      total: 0,
      currentPage: 1,
      loading: false
    }
  },
  created(){
    this.getList()
  },
  methods:{
    getList(){
      this.loading = true
      dynamics({
        current:this.currentPage,
        size:10,
        type:20
      }).then(res=>{
        if(res.data.code==200){
          this.total=res.data.data.total
          this.list=res.data.data.records.map(v=>{
            let dateData=this.getDate(v.createTime)
            v.date=dateData.newDates,
            v.day=dateData.day
            return v
          })
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    toDetails(data){
       this.$router.push(
        { path: '/associationNews/details',query: { id: data.id } }
        )
        let routerList=[]
        let routers = ['/specialColumn','resourceCenterVisitForms', '/associationNews/details'];
        for (let i = 0; i < routers.length; i++) {
          let routerData=findRoute(this.$router.options.routes, routers[i])
          routerList.push(routerData)
        }
        this.$store.commit('routerData/changeRouterList',routerList)
    },
    changePage(page){
      this.currentPage = page
      this.getList()
    },
    getDate(dateString){
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      return {
        day,
        newDates:year+'-'+(month<10?('0'+month):month)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.visit-forms {
  width: 100%;
}
</style>
